import type { ComponentType } from 'react';
import { DiscordIcon, TelegramIcon, XIcon } from '@/components/icons';
import { FaInstagram, FaTiktok } from 'react-icons/fa';

export type SocialLink = {
	label: string;
	href: string;
	Icon: ComponentType<{ className?: string }>;
};

export const SOCIAL_LINKS: SocialLink[] = [
	{
		label: 'Suigar on X',
		href: 'https://x.com/Suigar_com',
		Icon: XIcon,
	},
	{
		label: 'Suigar on Telegram',
		href: 'https://t.me/suigarofficial',
		Icon: TelegramIcon,
	},
	{
		label: 'Suigar on Discord',
		href: 'https://discord.gg/tAYGd46ZUK',
		Icon: DiscordIcon,
	},
	{
		label: 'Suigar on Instagram',
		href: 'https://instagram.com/suigar_com',
		Icon: FaInstagram,
	},
	// {
	// 	label: 'Suigar on TikTok',
	// 	href: 'https://www.tiktok.com/@suigar',
	// 	Icon: FaTiktok,
	// },
];
